import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-text"]
const _hoisted_2 = { class: "truncate text-start" }
const _hoisted_3 = {
  class: "overflow-hidden",
  style: {
        direction: 'rtl',
      }
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-[0] w-0" }, "a", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-[0] w-0" }, "a", -1)

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'trim-text-middle',
  props: {
    text: null
  },
  setup(__props: any) {

const props = __props as { text: string }


const mid = computed(() => Math.ceil((props.text.length + 1) / 2));
const start = computed(() => props.text.substring(0, mid.value));
const end = computed(() => props.text.substring(mid.value));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex flex-row flex-nowrap w-full content-start gap-0",
    "data-text": __props.text
  }, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(start)), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createTextVNode(_toDisplayString(_unref(end)), 1),
      _hoisted_5
    ])
  ], 8, _hoisted_1))
}
}

})